import { appFeatures } from "AppFeatures"
import { rootStore } from "store/RootStore"
import { observer } from "mobx-react"
import { useEffect, useState } from "react"
import { PinEntryDialog } from "scenes/components/Login"

export const AdultPinGuard = observer(({ channel, disablePortal, action, onClose }) => {

	/*
	console.debug("AdultPinGuard", channel, rootStore.channelsService?.isChannelPinProtected(channel.id),
		action, onClose)
	*/

	const [open, setOpen] = useState(false)

	useEffect(() => {
		const isProtected = rootStore.channelsService?.isChannelPinProtected(channel.id)

		if (!isProtected) {
			//console.debug("handleAction not protected")
			action(channel)
		} else {
			//console.debug("handleAction protected")
			setOpen(true)
		}
	}, [channel])

	const onPinEntered = async (pin) => {
		try {
			await rootStore.sso.profile.tryPinCode(pin)
			appFeatures.isAdultContentProtected = false
			//console.debug("handleAction onPinEntered")
			action(channel)
		} catch (err) {
			// display yellow error field
			throw err
		}
	}

	if (!open) return null

	return (
		<PinEntryDialog
			disablePortal={disablePortal}
			open={open}
			onPinDone={onPinEntered}
			onClose={onClose}
			profileName={rootStore.sso.profile?.name}
			info={"Settings"}
			flags={{ enableLogoff: false, fullScreen: false, restorePos: true }}
      />
	)
})


export const useAdultPinGuard = (onSuccessCallback) => {
	const [pendingChannel, setPendingChannel] = useState(null)

	const handleProtectedClick = (channel, disablePortal = false) => {
		if (channel) setPendingChannel({channel: channel, disablePortal: disablePortal})
		// fall through
		else onSuccessCallback(channel)
	}
	const handlePinClose = () => setPendingChannel(null)

	const handlePinSuccess = (channel) => {
		if (onSuccessCallback) onSuccessCallback(pendingChannel.channel)
		setPendingChannel(null)
	}

	const PinGuardElement = pendingChannel ? (
		<AdultPinGuard
			channel={pendingChannel.channel}
			disablePortal={pendingChannel.disablePortal}
			action={handlePinSuccess}
			onClose={handlePinClose}
		/>
	) : null

	return {
		handleProtectedClick,
		PinGuardElement
	}
}
